import { Form } from '@mairistem/composants';
import { Panel } from '@mairistem/finances-utils';
import { isNull, isUndefined } from 'lodash';
import React from 'react';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import CustomCheckbox from '../../Common/CustomCheckbox';

const CovidComponent = ({
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (_e, { name }) =>
		onChange?.({ [name]: !data?.covid19 }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Field
					control={CustomCheckbox}
					indeterminate={
						isUndefined(data?.covid19) ? false : !!isNull(data?.covid19)
					}
					name="covid19"
					checked={data?.covid19 ?? false}
					label="‎"
					libelle="Entre dans les dépenses aidées"
					onChange={handleChange}
					data-testid="covidCheckbox"
				/>
			</Form>
		</Panel>
	);
};

export default CovidComponent;
